import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-595d1dbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "codes" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-eye-dropper fa" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-eye-dropper fa" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-eye-dropper fa" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-eye-dropper fa" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Nuevo ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Antiguo ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" IoT ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-file-pdf fas" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No hay cámaras para configurar", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "No hay informes automáticos para este punto.", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Editar ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Crear nuevo informe ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Cancelar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_parameter_dialog_component = _resolveComponent("parameter-dialog-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_parameter_dialog_component_client = _resolveComponent("parameter-dialog-component-client")!
  const _component_colour_dialog_component = _resolveComponent("colour-dialog-component")!
  const _component_camera_config_component = _resolveComponent("camera-config-component")!
  const _component_TmoaInfoDialog = _resolveComponent("TmoaInfoDialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      model: _ctx.samplingPointForm,
      rules: _ctx.rules,
      "label-position": "top",
      ref: "form"
    }, {
      default: _withCtx(() => [
        (!_ctx.modify)
          ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              gutter: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "never",
                  class: "app-form-item",
                  style: {"width":"99%"}
                }, {
                  header: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("label.infoSamplingPoint")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 7 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "container",
                              label: _ctx.$t('label.container')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.samplingPointForm.container,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.samplingPointForm.container) = $event)),
                                  "value-key": "id",
                                  filterable: "",
                                  onChange: _ctx.checkSamplintPointType
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.containers, (option) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: option.id,
                                        label: option.name,
                                        value: option
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onChange"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 9 }, {
                          default: _withCtx(() => [
                            (_ctx.switchSamplintPointType && _ctx.samplingPointForm.container)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  prop: "samplingPointType",
                                  label: _ctx.$t('label.samplingPointType')
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.switchSamplintPointType && _ctx.samplingPointForm.container)
                                      ? (_openBlock(), _createBlock(_component_el_select, {
                                          key: 0,
                                          modelValue: _ctx.samplingPointForm.samplingPointType,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.samplingPointForm.samplingPointType) = $event)),
                                          "value-key": "id",
                                          onChange: _ctx.makesequence,
                                          "no-data-text": "",
                                          filterable: ""
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.samplingPointForm.container.containerType?.samplingPointType, (option) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: option.id,
                                                label: option.name,
                                                value: option
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "onChange"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 1,
                                  label: _ctx.$t('label.samplingPointType')
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      style: {"width":"100%"},
                                      modelValue: _ctx.samplingPointForm.samplingPointType,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.samplingPointForm.samplingPointType) = $event)),
                                      disabled: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 7 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                              _createVNode(_component_el_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("label.sequence")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.sequence), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        (_ctx.samplingPointForm.name !== undefined)
                          ? (_openBlock(), _createBlock(_component_el_text, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("label.name")) + ": " + _toDisplayString(_ctx.samplingPointForm.name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        (_ctx.samplingPointForm.code !== undefined)
                          ? (_openBlock(), _createBlock(_component_el_text, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("label.code")) + ":" + _toDisplayString(_ctx.samplingPointForm.code), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_row, {
              key: 1,
              gutter: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "never",
                  class: "app-form-item",
                  style: {"width":"100%"}
                }, {
                  header: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("label.infoSamplingPoint")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { span: 10 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_text, { class: "textsModels" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.nameContainer")) + " " + _toDisplayString(_ctx.samplingPointForm.name), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "container",
                          label: _ctx.$t('label.container')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointForm.container.name,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.samplingPointForm.container.name) = $event)),
                              placeholder: "{{ samplingPointForm.container?.name }}",
                              "value-key": "id",
                              style: {"width":"100%"},
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "container",
                          label: _ctx.$t('label.code')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointForm.code,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.samplingPointForm.code) = $event)),
                              placeholder: "{{ samplingPointForm.code }}",
                              style: {"width":"100%"},
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })),
        _createVNode(_component_el_card, {
          shadow: "never",
          class: "app-form-item"
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("label.address")), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "utmX",
                      label: _ctx.$t('label.utmX')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.samplingPointForm.utmX,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.samplingPointForm.utmX) = $event)),
                          min: 0,
                          step: 1,
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "utmY",
                      label: _ctx.$t('label.utmY')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.samplingPointForm.utmY,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.samplingPointForm.utmY) = $event)),
                          min: 0,
                          step: 1,
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "timeZone",
                      label: _ctx.$t('label.timeZone')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.samplingPointForm.timeZone,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.samplingPointForm.timeZone) = $event)),
                          min: 0,
                          step: 1,
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "hemisphere",
                      label: " Hemisferio "
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          clearable: "",
                          modelValue: _ctx.samplingPointForm.hemisphere,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.samplingPointForm.hemisphere) = $event)),
                          "value-key": "id",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hemisphereList, (option) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: option.label,
                                label: option.label,
                                value: option.label
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "never",
          class: "app-form-item"
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("label.station")), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { prop: "station" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.samplingPointForm.station,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.samplingPointForm.station) = $event)),
                          "value-key": "id",
                          style: {"width":"100%"},
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('label.noStation'),
                              value: null
                            }, null, 8, ["label"]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations, (option) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: option.id,
                                label: option.name,
                                value: option
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "never",
          class: "app-form-item"
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("label.modelIa")) + " ", 1),
            _createVNode(_component_el_switch, {
              modelValue: _ctx.samplingPointForm.throughModel,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.samplingPointForm.throughModel) = $event))
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            (!_ctx.samplingPointForm.hasAllParameters)
              ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_text, { class: "textsModels" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("text.parameterFalse")), 1)
                      ]),
                      _: 1
                    }),
                    _hoisted_2,
                    _createVNode(_component_el_link, {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openDialogParameter())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("label.parameterAssign")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_row, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_text, { class: "textsModels" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("text.parameterTrue")), 1)
                      ]),
                      _: 1
                    }),
                    _hoisted_3,
                    _createVNode(_component_el_link, {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openDialogParameter())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("label.parameterAssign")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })),
            _createVNode(_component_el_row, {
              label: _ctx.$t('label.colour')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { class: "textsModels" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("text.cameraThroughModel")), 1)
                  ]),
                  _: 1
                }),
                _hoisted_4,
                _createVNode(_component_el_link, {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openDialogCamera())),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("label.modelCamera")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_row, {
              label: _ctx.$t('info_tmoa.title_info' + ': ')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { class: "textsModels" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("info_tmoa.title_info")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.samplingPointForm.numTmoa,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.samplingPointForm.numTmoa) = $event)),
                      type: "number",
                      min: 0,
                      width: 200,
                      disabled: _ctx.disableNumTmoa
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                (_ctx.samplingPointForm.numTmoa > 0)
                  ? (_openBlock(), _createBlock(_component_el_text, { key: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_5,
                        _createVNode(_component_el_link, {
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openDialogTmoas())),
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("info_tmoa.title_info")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { class: "textsModels" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("label.intervalEstimation")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "intervalEstimation" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.samplingPointForm.intervalEstimation,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.samplingPointForm.intervalEstimation) = $event)),
                      min: 0,
                      type: "number",
                      class: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_popover, {
                  placement: "bottom",
                  title: _ctx.$t('label.intervalEstimation'),
                  width: 273,
                  trigger: "click",
                  class: "popover-info",
                  content: _ctx.$t('info.samplingPointForm_interval')
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "info",
                      size: "small",
                      circle: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["title", "content"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              shadow: "never",
              class: "app-form-item"
            }, {
              header: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("label.labelling")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_row, { gutter: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("label.labellingType")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "labellingScript" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_radio_group, {
                                modelValue: _ctx.samplingPointForm.labellingScript,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.samplingPointForm.labellingScript) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio, { label: 'new' }, {
                                    default: _withCtx(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_radio, { label: 'old' }, {
                                    default: _withCtx(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_radio, { label: 'iot' }, {
                                    default: _withCtx(() => [
                                      _hoisted_9
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { gutter: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { md: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "Min " }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointForm.minBlack,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.samplingPointForm.minBlack) = $event)),
                              type: "number"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { md: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "Max" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointForm.maxWhite,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.samplingPointForm.maxWhite) = $event)),
                              type: "number"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { md: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "Punto y" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointForm.yBright,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.samplingPointForm.yBright) = $event)),
                              type: "number"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { md: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "Punto x" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointForm.xBright,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.samplingPointForm.xBright) = $event)),
                              type: "number"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { md: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "Alto (dy)" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointForm.dyBright,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.samplingPointForm.dyBright) = $event)),
                              type: "number"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { md: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "Ancho (dx)" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointForm.dxBright,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.samplingPointForm.dxBright) = $event)),
                              type: "number"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { gutter: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('label.minAreaPercentage')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointLabel.minArea,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.samplingPointLabel.minArea) = $event)),
                              type: "number"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('label.minPixelPercentage')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointLabel.minPixel,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.samplingPointLabel.minPixel) = $event)),
                              type: "number"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('label.whiteThreshold')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointLabel.whiteThreshold,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.samplingPointLabel.whiteThreshold) = $event)),
                              type: "number"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('label.blackThreshold')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.samplingPointLabel.blackThreshold,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.samplingPointLabel.blackThreshold) = $event)),
                              type: "number"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "never",
          class: "app-form-item"
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("label.assignResponsible")), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, { "label-width": "120px" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('label.responsible') + ': '
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.samplingPointForm.responsible,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.samplingPointForm.responsible) = $event)),
                              multiple: "",
                              filterable: "",
                              placeholder: "Selecciona usuarios",
                              "collapse-tags": false,
                              style: {"width":"100%"},
                              "value-key": "id"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: user.id,
                                    label: user.email,
                                    value: user
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "never",
          class: "app-form-item"
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("menu.report")), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _createVNode(_component_el_link, {
                      onClick: _ctx.openPopupReport,
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("title.autoReport")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("template", null, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showParameters,
        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.showParameters) = $event)),
        width: "30%",
        title: _ctx.$t('label.parameterAssign'),
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.closeEntityDialog()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.saveParameters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.accept")), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (_ctx.showParameters)
            ? (_openBlock(), _createBlock(_component_parameter_dialog_component, {
                key: 0,
                parameters: _ctx.samplingPointForm.parameters,
                hasAllParameters: _ctx.samplingPointForm.hasAllParameters,
                ref: "parameterDialog"
              }, null, 8, ["parameters", "hasAllParameters"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _createElementVNode("template", null, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showParametersClient,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.showParametersClient) = $event)),
        width: "30%",
        title: _ctx.$t('label.parameterAssignClient'),
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.closeEntityDialog()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.saveParametersClient()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.accept")), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (_ctx.showParametersClient)
            ? (_openBlock(), _createBlock(_component_parameter_dialog_component_client, {
                key: 0,
                parameters: _ctx.samplingPointForm.parametersClient,
                ref: "parameterDialog"
              }, null, 8, ["parameters"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _createElementVNode("template", null, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showColour,
        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.showColour) = $event)),
        width: "30%",
        title: _ctx.$t('label.colourAssign'),
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.closeEntityDialog()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.saveCodeFromChild()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.accept")), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (_ctx.showColour)
            ? (_openBlock(), _createBlock(_component_colour_dialog_component, {
                key: 0,
                ref: "colourDialog",
                samplingPointForm: _ctx.samplingPointForm,
                onCodeUpdate: _ctx.updateCode
              }, null, 8, ["samplingPointForm", "onCodeUpdate"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    (_ctx.showCamera)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.showCamera,
          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.showCamera) = $event)),
          width: "40%",
          title: _ctx.$t('label.modelCamera'),
          "append-to-body": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.updateCamerasModelStation(_ctx.camerasConfiguration))),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.accept")), 1)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            (_ctx.showCamera)
              ? (_openBlock(), _createBlock(_component_camera_config_component, {
                  key: 0,
                  ref: "cameraDialog",
                  samplingPointForm: _ctx.samplingPointForm,
                  onCodeUpdate: _ctx.updateCode
                }, null, 8, ["samplingPointForm", "onCodeUpdate"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.camerasConfiguration, (camera, index) => {
              return (_openBlock(), _createBlock(_component_el_card, {
                shadow: "never",
                class: "app-form-item",
                key: index
              }, {
                default: _withCtx(() => [
                  (_ctx.camerasConfiguration.length > 0)
                    ? (_openBlock(), _createBlock(_component_el_text, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(camera.camera?.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_switch, {
                            modelValue: camera.modele,
                            "onUpdate:modelValue": ($event: any) => ((camera.modele) = $event),
                            onChange: ($event: any) => (_ctx.changeCamera(camera))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(camera.modele ? "true" : "false"), 1)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]),
                          _createVNode(_component_el_select, {
                            modelValue: camera.imageProcessingTime,
                            "onUpdate:modelValue": ($event: any) => ((camera.imageProcessingTime) = $event),
                            placeholder: "Seleccione modo",
                            style: {"margin-left":"10px"},
                            onChange: ($event: any) => (_ctx.ckeckCamera(camera)),
                            disabled: !camera.modele
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: _ctx.$t('label.day'),
                                value: "DAY"
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_option, {
                                label: _ctx.$t('label.night'),
                                value: "NIGHT"
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_option, {
                                label: _ctx.$t('label.all_day'),
                                value: "ALL_DAY"
                              }, null, 8, ["label"])
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (_ctx.camerasConfiguration.length <= 0)
              ? (_openBlock(), _createBlock(_component_el_text, { key: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "title"]))
      : _createCommentVNode("", true),
    _createVNode(_component_TmoaInfoDialog, {
      modelValue: _ctx.showTmoas,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.showTmoas) = $event)),
      tmoas: _ctx.tmoas,
      "sampling-point-id": _ctx.id
    }, null, 8, ["modelValue", "tmoas", "sampling-point-id"]),
    (_ctx.showReport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_el_dialog, {
            modelValue: _ctx.showReport,
            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.showReport) = $event)),
            title: _ctx.$t('title.autoReport'),
            width: "600px"
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.createNewReport
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              (_ctx.reports.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                : (_openBlock(), _createBlock(_component_el_table, {
                    key: 1,
                    data: _ctx.reports,
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "name",
                        label: "Nombre"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "frequency",
                        label: "Frecuencia"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "active",
                        label: "Estado"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.active ? "Activo" : "No Activo"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Acciones",
                        width: "120"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            size: "small",
                            onClick: ($event: any) => (_ctx.editReport(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]))
            ]),
            _: 1
          }, 8, ["modelValue", "title"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showReportForm,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.showReportForm) = $event)),
      width: "600px",
      title: _ctx.editingReport ? 'Editar informe' : 'Nuevo informe',
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: _ctx.cancelReport }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.saveReport
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.editingReport ? "Guardar cambios" : "Crear informe"), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.currentReport,
          ref: "reportForm",
          rules: _ctx.reportRules,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 18 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Nombre",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.currentReport.name,
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.currentReport.name) = $event)),
                          style: {"width":"90%"},
                          onInput: _ctx.onNameInput
                        }, null, 8, ["modelValue", "onInput"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Activo",
                      prop: "active"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.currentReport.active,
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.currentReport.active) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Frecuencia",
              prop: "frequency"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.currentReport.frequency,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.currentReport.frequency) = $event)),
                  placeholder: "Selecciona frecuencia",
                  style: {"width":"100%"},
                  onChange: _ctx.onFrequencyChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Diario",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Semanal",
                      value: 7
                    }),
                    _createVNode(_component_el_option, {
                      label: "Mensual",
                      value: 30
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Correos" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.currentReport.mails,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.currentReport.mails) = $event)),
                  multiple: "",
                  filterable: "",
                  "allow-create": "",
                  "default-first-option": "",
                  placeholder: "Añade uno o varios correos",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}